<template>
  <div v-if="cart" :class="['cart-large', { 'shadow-none': isMobile }]">
    <div
      :class="[
        'header mt-0 d-flex align-items-center border-bottom-0 pb-0',
        {
          'p-0': isMobile && title === 'Review and Place Order',
          'px-4': isMobile && title === 'My Cart'
        }
      ]"
      v-if="type == 'big'"
    >
      <img
        src="@/assets/images/ic-arrow-left.svg"
        class="d-inline d-md-none mr-3 cursor-pointer"
        @click="$router.go(-1)"
        v-if="title === 'My Cart'"
      />
      <CheckoutDetailsHeader class="px-0 w-100 mb-0" v-if="!isMobile || title === 'My Cart'">{{ title }}</CheckoutDetailsHeader>
    </div>
    <div class="cart-body pt-2 scrollable" v-if="cart.data.cart_count > 0">
      <div
        :class="['cart-item mb-10 mt-0', { 'px-0': isMobile }]"
        v-for="(brandBranch, index) in brandBranch"
        :key="index"
      >
        <h2 class="d-flex justify-content-between mb-3">
          {{ brandBranch.brand }} ({{ brandBranch.branch }})
        </h2>
        <b-row
          class="pb-3 border-bottom"
          v-if="
            showFulfillment && isBranchDetailsDataLoaded && brandBranch.details
          "
        >
          <b-col md="6">
            <b-form-group label="Logistic Type" label-size="sm">
              <b-dropdown class="dropdown-select" variant="link" no-caret>
                <template slot="button-content">
                  <div class="d-flex justify-content-between">
                    <div>
                      {{
                        brandBranch.details.logisticTypeOptions[
                          brandBranch.details.selectedLogisticType
                        ].name
                      }}
                    </div>
                    <img src="@/assets/images/dropdown.svg" alt="Dropdown" />
                  </div>
                </template>
                <b-dropdown-item
                  v-for="(logisticType, key) in brandBranch.details.logisticTypeOptions"
                  :key="key"
                  @click="selectBranchLogisticType(brandBranch, key, index)"
                >
                  {{ logisticType.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
          </b-col>
          <b-col md="6" class="d-flex flex-column justify-content-center">
            <div
              class="bg-light rounded p-2 mt-2 d-flex justify-content-between"
              :style="[
                brandBranch.details.selectedLogisticType.includes('now')
                  ? { opacity: 0.4, cursor: 'not-allowed' }
                  : { opacity: 1, cursor: 'pointer' }
              ]"
              @click="
                brandBranch.details.selectedLogisticType.includes('now')
                  ? null
                  : showScheduleModal(brandBranch)
              "
            >
              <div>
                <b-img
                  :src="require('@/assets/images/calendar.png')"
                  alt="Calendar"
                />
                <span class="ml-1 align-middle">
                  {{
                    brandBranch.details.selectedSchedule
                      ? brandBranch.details.selectedSchedule
                      : "Select Schedule"
                  }}
                </span>
              </div>
              <b-img
                :src="require('@/assets/images/chevron-right.png')"
                alt="Chevron Right"
              />
            </div>
          </b-col>
        </b-row>
        <div
          :class="{ container: !isMobile }"
          v-for="(order, oindex) in formattedOrders"
          :key="oindex"
        >
          <div
            class="row mt-20 mb-20 no-gutters"
            v-if="
              order.branch == brandBranch.branch &&
                order.brand == brandBranch.brand
            "
          >
            <div class="col-2">
              <img :src="order.image" style="max-width: 100%" />
            </div>
            <div class="col-2 aCenter cart-count">
              {{ parseInt(order.quantity) }}x
            </div>
            <div class="col-4 cart-desc">
              <p class="text-break">{{ order.name }}</p>
              <span
                v-show="order.product_type == 'variable'"
                v-html="formatAttribute(order.decoded_variation)"
              ></span>
              <span v-if="order.add_ons.length > 0">
                {{ order.add_ons.map(addon => addon.name).join(" + ") }}
              </span>
            </div>
            <div class="col-4 cart-price text-right">
              Php {{ putComma(Number(order.total_amount).toFixed(2)) }}
            </div>
          </div>
        </div>
        <!-- Start: Per Branch Fees -->
        <div class="branchFees" v-if="type === 'big'">
          <div
            v-for="(fee, index) in brandBranch.fees"
            :key="`per_branch_fee_${index}`"
            class="d-flex"
          >
            <template
              v-if="fee.name === 'Delivery Fee' && hideDeliveryFee"
            ></template>
            <template
              v-else-if="fee.name === 'Delivery Fee' && fee.calculated_amount === 0"
            >
              <span class="flex-grow-1">Delivery Fee</span>
              <span>FREE</span>
            </template>
            <template v-else>
              <span class="flex-grow-1">{{ fee.name }}</span>
              <span>{{ `Php ${fee.calculated_amount.toFixed(2)}` }}</span>
            </template>
          </div>
        </div>
        <!-- End: Per Branch Fees -->
      </div>
    </div>
    <div class="cart-empty py-4" v-else>
      <p style="text-align: center">
        No items in the cart yet.
      </p>
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="
        type === 'big' &&
          $route.path.split('/').pop() === 'checkout' &&
          isMobile
      "
    >
      <b
        :style="{
          color:
            webDesign !== null && webDesign.design !== null
              ? webDesign.design.main_color
              : '#ff8a00'
        }"
        >Less Details</b
      >
      <img
        src="@/assets/images/arrow-down.svg"
        class="order-summary-collapse"
        v-b-toggle.order-summary-collapse
        ref="orderSummaryToggle"
      />
    </div>
    <ScheduleModal :brand-branch="selectedBrandBranch" ref="scheduleModal" />
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import ScheduleModal from "@/components/cart/ScheduleModal";
import CheckoutDetailsHeader from "@/components/checkout/CheckoutDetailsHeaderTemplate";

export default {
  name: "Cart",
  components: { ScheduleModal, CheckoutDetailsHeader },
  props: ["title", "type", "editable", "showFulfillment"],
  computed: {
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    ...mapState("estore", {
      cart: state => state.cart,
      products: state => state.products,
      estoreIsLoadingOverlay: state => state.loadingOverlay,
      estoreIsLoading: state => state.loading,
      estoreErrors: state => state.errors,
      webDesign: state => state.webDesign,
      deliverPickUp: state => state.deliverPickUp,
      coordinates: state => state.coordinates
    }),
    ...mapState("organization", ["branchDetails"]),
    ...mapGetters({
      getDeliveryConfig: "estore/getDeliveryConfig"
    })
  },
  created: async function() {
    await this.formatData();

    this.isMobile = window.innerWidth < 991;
  },
  data() {
    return {
      isConfirmRemove: false,
      brandBranch: null,
      formattedOrders: null,
      visible: true,
      isMobile: false,
      selectedDelivery: null,
      showOptions: false,
      deliverLaterDates: null,
      selectedDeliverLaterDate: null,
      timeOptions: [],
      selectedTime: null,
      selectedPickupTime: null,
      pickUpLaterDates: null,
      selectedPickUpLaterDate: null,
      cutoffMessage: null,
      isBranchDetailsDataLoaded: false,
      selectedBrandBranch: null,
      hideDeliveryFee: true
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 845;
    });
    this.$root.$on("updateHideDeliveryFee2", async (el) => {
      this.hideDeliveryFee = el;
      await this.formatData();
    });
  },
  methods: {
    getBrandBranch() {
      if (this.cart && this.cart.data.list) {
        let brandBranch = this.cart.data.list.map(obj => {
          let newBrand = {};
          newBrand["brand"] = obj.brand_name;
          newBrand["brand_uuid"] = obj.brand_uuid;
          newBrand["branch"] = obj.branch_name;
          newBrand["branch_uuid"] = obj.branch_uuid;
          newBrand["removeAllModal"] = false;
          newBrand["logisticType"] = obj.delivery_type;
          newBrand["scheduledDate"] = obj.pickup_datetime;
          newBrand["fees"] = obj.fees;
          newBrand["deliveryOptions"] = false;
          newBrand["dateTime"] = false;
          newBrand["lat"] = obj.lat;
          newBrand["lng"] = obj.lng;
          return newBrand;
        });
        this.brandBranch = brandBranch;
      }
    },
    formatOrders() {
      if (this.cart && this.cart.data.list) {
        let brandBranch = this.brandBranch;

        let newCart = [];
        for (let h = 0; h < brandBranch.length; h++) {
          for (let i = 0; i < this.cart.data.list.length; i++) {
            for (let j = 0; j < this.cart.data.list[i].items.length; j++) {
              if (
                this.cart.data.list[i].branch_name ==
                  brandBranch[h].branch &&
                this.cart.data.list[i].brand_name == brandBranch[h].brand
              ) {
                newCart.push({
                  branch: brandBranch[h].branch,
                  brand: brandBranch[h].brand,
                  branch_uuid: brandBranch[h].branch_uuid,
                  name: this.cart.data.list[i].items[j].product_inventory
                    .product_details.name,
                  quantity: parseInt(this.cart.data.list[i].items[j].quantity),
                  total_amount: this.cart.data.list[i].items[j].total_amount,
                  image:
                    this.cart.data.list[i].items[j].product_inventory.product_details
                      .images.length > 0
                      ? this.cart.data.list[i].items[j].product_inventory
                          .product_details.images[0].image_name
                      : null,
                  product_uuid: this.cart.data.list[i].items[j].product_inventory
                    .product_details.uuid,
                  item_uuid: this.cart.data.list[i].items[j].uuid,
                  visible: false,
                  product_type: this.cart.data.list[i].items[j].product_inventory
                    .product_details.type,
                  decoded_variation: this.cart.data.list[i].items[j]
                    .product_inventory.decoded_variation_code,
                  stock: this.cart.data.list[i].items[j].product_inventory.stock,
                  is_limited_stock: this.cart.data.list[i].items[j].product_inventory
                    .is_limited_stock,
                  add_ons: this.cart.data.list[i].items[j].add_ons
                });
              }
            }
          }
        }
        this.formattedOrders = newCart;
      }
    },
    formatAttribute(decoded_variation) {
      let variations = decoded_variation.map(function(obj) {
        return obj.attribute + " - " + obj.value;
      });

      return variations.join("<br/>");
    },
    async viewCart() {
      const { checkout_uuid } = this.$route.params;
      if (
        this.customerPortalToken &&
        this.coordinates &&
        Object.keys(this.coordinates).length > 0
      ) {
        this.isBranchDetailsDataLoaded = false;
        const request = {
          checkout_uuid: checkout_uuid,
          header: {
            "X-Merchant-Token": this.customerPortalToken
          }
        }

        await this.$store.dispatch("estore/viewCart", request);
        if (!this.estoreErrors) await this.$store.dispatch("customer/getCustomerToken", request);
      }
    },
    async formatData() {
      this.getBrandBranch();
      this.formatOrders();

      if (this.showFulfillment && this.cart && this.cart.data.list) {
        this.isBranchDetailsDataLoaded = false;

        const branchDetailsPromises = this.brandBranch.map(
          async (item, index) => {
            await this.getBranchDetails(item.branch_uuid);

            const {
              deliver_now,
              scheduled_delivery,
              pickup_now,
              scheduled_pickup
            } = this.branchDetails;

            const logisticTypeOptions = {
              ...(deliver_now.enable && { deliver_now }),
              ...(scheduled_delivery.enable && { scheduled_delivery }),
              ...(pickup_now.enable && { pickup_now }),
              ...(scheduled_pickup.enable && { scheduled_pickup })
            };
            let selectedLogisticType = "";

            if (
              item.logisticType === "Delivery" &&
              logisticTypeOptions.deliver_now
            ) {
              selectedLogisticType = "deliver_now";
            }

            if (
              item.logisticType === "Pickup" &&
              logisticTypeOptions.pickup_now
            ) {
              selectedLogisticType = "pickup_now";
            }

            if (
              item.logisticType === "Scheduled Delivery" &&
              logisticTypeOptions.scheduled_delivery
            ) {
              selectedLogisticType = "scheduled_delivery";
            }

            if (
              item.logisticType === "Scheduled Pickup" &&
              logisticTypeOptions.scheduled_pickup
            ) {
              selectedLogisticType = "scheduled_pickup";
            }

            let selectedSchedule = "";

            if (item.scheduledDate && moment(item.scheduledDate).isValid())
              selectedSchedule = moment(item.scheduledDate).format(
                "MMM DD, LT"
              );

            item.details = {
              ...this.branchDetails,
              logisticTypeOptions,
              selectedLogisticType,
              selectedSchedule
            };

            if (!selectedLogisticType) {
              selectedLogisticType = Object.keys(logisticTypeOptions)[0];
              item.details.selectedLogisticType = selectedLogisticType;
              await this.selectBranchLogisticType(
                item,
                selectedLogisticType,
                index
              );
            }
          }
        );
        await Promise.all(branchDetailsPromises);

        this.isBranchDetailsDataLoaded = true;
      } else this.isBranchDetailsDataLoaded = true;
    },
    showModal(branch_uuid, product_uuid, item_uuid, stock, is_limited_stock) {
      this.$refs.modal.showModal(
        branch_uuid,
        product_uuid,
        item_uuid,
        stock,
        is_limited_stock
      );
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // get delivery details from local storage
    getDeliveryDetails(uuid) {
      return localStorage.getItem(`delivery_details_${uuid}`);
    },
    async getBranchDetails(branchUuid) {
      await this.$store.dispatch("organization/getBranchDetails", {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        branch_uuid: branchUuid
      });
    },
    showScheduleModal(brandBranch) {
      this.selectedBrandBranch = brandBranch;
      this.$root.$emit("bv::show::modal", "schedule-modal");
    },
    async selectBranchLogisticType(brandBranch, logisticType, index) {
      this.isBranchDetailsDataLoaded = false;
      brandBranch.details.selectedLogisticType = logisticType;
      brandBranch.details.selectedSchedule = null;
      brandBranch.scheduledDate = null;

      this.$nextTick(() => {
        this.isBranchDetailsDataLoaded = true;
      });

      if (logisticType === "deliver_now") {
        await this.updateLogisticType(brandBranch, "Delivery");
      }

      if (logisticType === "pickup_now") {
        await this.updateLogisticType(brandBranch, "Pickup");
      }

      if (logisticType === "scheduled_delivery") {
        this.cart.data.list[index].delivery_type = "Scheduled Delivery";
        this.cart.data.list[index].pickup_datetime = null;
      }

      if (logisticType === "scheduled_pickup") {
        this.cart.data.list[index].delivery_type = "Scheduled Pickup";
        this.cart.data.list[index].pickup_datetime = null;
      }
    },
    async updateLogisticType(brandBranch, logisticType) {
      const { checkout_uuid } = this.$route.params;
      const request = {
        checkout_uuid: checkout_uuid,
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          branch_uuid: brandBranch.branch_uuid,
          delivery_type: logisticType
        }
      };
      
      await this.$store.dispatch("estore/updateDelivery", request);
      await this.viewCart();
      await this.formatData();
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../../assets/styles/views/cart/_base.scss";
.remove-all-modal {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  width: 180px;
  text-align: center;
  padding: 15px 20px;
  z-index: 2;
  position: absolute;

  label {
    text-align: center;
    font-family: Muli;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #2f3941;
  }
  ul {
    margin: 10px 0px;
    list-style: none;
    padding: 0px;
    li {
      width: 50%;
      display: inline-block;
      font-family: Muli;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;

      cursor: pointer;

      &:last-child {
        color: $orange;
      }
    }
  }
}
.branchFees {
  color: #87929d;
  font-size: 14px !important;
  padding: 15px 0;
}
.cursor-pointer {
  cursor: pointer;
}
.order-summary-collapse {
  outline: 0;
  transition: all ease 0.2s;
  &.not-collapsed {
    transform: rotate(180deg);
  }
}

#logistics-type {
  height: 40px;
  width: 100%;
  padding: 8px;
  background-color: lightgray;
  position: relative;
  cursor: pointer;
}

#logistics-type-active {
  margin-top: -40px;
  height: 40px;
  width: 100%;
  padding: 8px;
  background-color: lightgray;
  position: relative;
  cursor: pointer;

  .options-container {
    margin-top: 32px;
    margin-left: -7px;
    background: #f0f0f0;
    z-index: 999;
    /* margin-bottom: 99px; */
    position: absolute;
    width: 100%;
    // padding: 0 8px;

    div {
      .option {
        cursor: pointer;
        padding: 8px;

        &:hover {
          background: #f9f9f9;
        }
      }
    }
  }
}
.scrollable {
  height: 50vh;
  overflow-y: auto;
}
</style>
